import React from "react";
import { useTranslation } from "react-i18next";

import {
  EmptyStateContainer,
  EmptyStateDescription,
  EmptyStateDetails,
  EmptyStateHeading,
} from "./styles";

import { getEmptyStateTemplate } from "./templates";

const EmptyState = ({ template = "" }) => {
  const { t } = useTranslation();
  const EMPTY_STATE_TEMPLATE = getEmptyStateTemplate(t);
  const state = EMPTY_STATE_TEMPLATE[template];

  if (!state) return null;

  return (
    <EmptyStateContainer>
      <EmptyStateDetails>
        <img src={state.imageUrl} alt={state.title} width={310} />
        <EmptyStateHeading>{state.title}</EmptyStateHeading>
        <EmptyStateDescription>{state.description}</EmptyStateDescription>
      </EmptyStateDetails>
    </EmptyStateContainer>
  );
};

export default EmptyState;
